import api from '../../services/api';
import { Contact } from '../../services/contacts-manager';

interface PatchContacts {
	create: Contact[];
	update: Contact[];
	delete: Contact[];
}

export const getContacts = async () => {
	return await api.get<Contact[]>(`/api/contact`).then(res => res.data);
};

export const patchContacts = async (body: PatchContacts) => {
	await api.patch(`/api/contact`, body);
};
